// Shim for tests
if (typeof BASE_URL === "undefined") {
    var BASE_URL = "..";
}

// Location for all of the image files, relative to the root
const BASE_IMAGE_PATH = `${BASE_URL}/app/`;

// File names for all icons
const iconFileName = {
    currentLocation: require('../images/current-location-marker.svg'),
    searchLocation: require('../images/search-location-marker.svg'),
    pharmacyMapIcon: require('../images/pharmacyIcon.svg'),
    pharmacyMapIconHover: require('../images/pharmacyIconHover.svg'),
    specialAuthority: require('../images/saIcon.svg'),
    specialAuthorityHover: require('../images/saIconWhite.svg'),
    standardProviderPin: require('../images/standardProviderPin.svg'),
    standardProviderPinHover: require('../images/standardProviderPinHover.svg'),
    preferredProviderPin: require('../images/preferredProvider.svg'),
    preferredProviderPinHover: require('../images/preferredProviderWhite.svg')
}

/**
 * Returns the full path for the icon/image filename
 * @param {string} iconKey - Key for the required image
 * @returns {string} Path for the image file
 */
export function getIcon(iconKey) {
    return BASE_IMAGE_PATH + iconFileName[iconKey];
}


// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/icons.js